import { createFileRoute } from '@tanstack/react-router'
import { MyProfilePage } from '@/pages/profile/my-profile/ui/MyProfilePage'

export const Route = createFileRoute('/my-profile')({ component: MyProfilePage })
